import React from "react";
import LegalPage from "../../components/LegalPage";

const PDF = "https://customer-assets.emergentagent.com/job_workflow-builder-125/artifacts/22ngm8ab_Zelaflo_Labs_Privacy_Policy.pdf";

export default function PrivacyPolicy() {
  return (
    <LegalPage
      title="Privacy Policy"
      pdfUrl={PDF}
      description="How we collect, use, and protect your personal information."
      testId="legal-privacy-policy"
    />
  );
}
